export interface IThreeDSecureStatus {
  value: string;
  description: string;
}
